import axios from 'axios';
import React, { useEffect, useState } from 'react';
import CancellationsApi from '../../../api/CancellationsApi';
import { handleUnauthorizedResponse } from '../../../api/http';
import { AuthData } from '../../../context/auth';
import { PolicyData, withPolicyContext } from '../../../context/policy';
import { CancellationResponse } from '../../../types/cancellations';
import CancellationsTable from '../../CancellationsTable';
import {
	StyledSectionContainer,
	StyledTitle,
	StyledTitleContainer,
} from '../../common';
import LargeCenterSpinner from '../../LargeCenterSpinner';
import { errorToast } from '../../Toast';

interface Props {
	authData: AuthData;
	policyData: PolicyData;
}

const CancellationsList = (props: Props) => {
	const { authData, policyData } = props;

	const { policy } = policyData;

	const [cancellations, setCancellations] = useState<CancellationResponse[]>(
		[],
	);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const source = axios.CancelToken.source();
		async function load() {
			try {
				const cancellationResponse =
					await CancellationsApi.getCancellationsForPolicy(
						authData.auth.authorizationToken,
						policy.locator,
						{ cancelToken: source.token },
					);
				if (cancellationResponse) {
					setCancellations(cancellationResponse.data);
				}
				setLoading(false);
			} catch (error) {
				if (axios.isCancel(error)) {
					return;
				} else {
					if (await handleUnauthorizedResponse(error, authData)) {
						return;
					}
					errorToast('Failed to fetch cancellations');
				}
			}
		}
		load();

		return () => {
			source.cancel();
		};
	}, []);

	if (loading) {
		return <LargeCenterSpinner />;
	}

	return (
		<>
			<StyledTitleContainer>
				<StyledTitle>Cancellations</StyledTitle>
			</StyledTitleContainer>
			<hr />
			<StyledSectionContainer>
				<CancellationsTable cancellations={cancellations} />
			</StyledSectionContainer>
		</>
	);
};

export default withPolicyContext<Props>(CancellationsList);
